import './AppHeader.css'

export const AppHeader = ({ liked, allPosts }) => {
    return (
        <div className="app-header d-flex">
            <h1>Axmadullo Ubaydullayev</h1>
            <h2>{ allPosts } posts, like { liked }</h2>
        </div>
    )
}

